import { render, staticRenderFns } from "./left_3.vue?vue&type=template&id=f1149ff0&scoped=true&"
import script from "./left_3.vue?vue&type=script&lang=js&"
export * from "./left_3.vue?vue&type=script&lang=js&"
import style0 from "./left_3.vue?vue&type=style&index=0&id=f1149ff0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1149ff0",
  null
  
)

export default component.exports